"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const optionToElement = (onChange, value, name) => (option, index) => {
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", id: option, name: name, checked: option === value, onChange: onChange, value: option }, void 0), (0, jsx_runtime_1.jsx)(Label, { index: index, htmlFor: option, children: (0, jsx_runtime_1.jsx)(H4Label, { children: option }, void 0) }, void 0)] }, option));
};
const Toggle = ({ options, value, onChange, name = "toggle" }) => {
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: options.map(optionToElement(onChange, value, name)) }, void 0));
};
exports.Toggle = Toggle;
const Wrapper = styled_components_1.default.div `
  display: flex;

  input[type="radio"] {
    display: none;
  }

  input:checked + label {
    background-color: ${(props) => props.theme.colors.greyBase};
    color: ${(props) => props.theme.colors.whiteBase};
    z-index: 10;
  }
`;
const Label = styled_components_1.default.label `
  align-items: center;
  background-color: ${(props) => props.theme.colors.silverBase};
  border-radius: ${(props) => props.theme.utils.radius};
  color: ${(props) => props.theme.colors.greyLighten70};
  display: flex;
  height: 2.25rem;
  justify-content: center;
  left: ${({ index }) => `calc(${index} * -0.5rem)`};
  position: relative;
  width: 5rem;
  &::first-letter {
    text-transform: capitalize;
  }
`;
const H4Label = (0, styled_components_1.default)(typography_1.H4) `
  color: inherit;
`;
//# sourceMappingURL=Toggle.js.map